import cn from '@/lib/clsxm';

import { SIZE_ENUM } from '@/components/@base/@helpers/types';
import Card from '@/components/@base/card';
import Container from '@/components/@base/container';
import { Text } from '@/components/@base/typography';
import { TEXT_TYPE } from '@/components/@base/typography/text/type';
import Medal from '@/components/shared/components/medal';
import { formatDate } from '@/components/shared/helpers';

import {
  DATA_CY_MEDAL_ICON,
  DATA_CY_MEDAL_TEXT,
  DATA_CY_STORE_MEDAL_CARD,
} from '@/constant/cypress';
import { pageLevelLocalization } from '@/constant/localization';
import StoreModel from '@/models/store.model';

import HeaderSection from './@shared/headerSection';

type MedalsCardProps = Pick<StoreModel, 'medals' | 'createdAt'> & {
  totalProducts: string;
};
export default function MedalsCard({ medals, createdAt, totalProducts }: MedalsCardProps) {
  const { store: storeLocalization } = pageLevelLocalization;

  return (
    <Card data-cy={DATA_CY_STORE_MEDAL_CARD} noBorder className={cn('relative mx-6 self-baseline p-8 lg:mx-0')}>
      <Container className='mb-4 grid grid-cols-2 border-b-[1px] border-gray-200 pb-3'>
        <HeaderSection
          subTitle={storeLocalization.the_date_of_joning}
          title={formatDate(createdAt, 'fa-IR', { year: 'numeric', month: 'short' })}
        />
        <HeaderSection subTitle={storeLocalization.released_product} title={totalProducts} />
      </Container>
      {medals?.map((item, index) => (
        <Container className='flex flex-row items-center gap-4 pb-3'>
          <Medal data-cy={DATA_CY_MEDAL_ICON}
            title={item.title}
            icon={item.icon}
            value={item.value}
            itemID={`store_medal_${index}`}
          />
          <Text data-cy={DATA_CY_MEDAL_TEXT}
            className='text-[15px] font-bold tracking-tighter text-[#5B5C60]'
            type={TEXT_TYPE.SPAN}
            size={SIZE_ENUM.MD}
          >
            {item.title}
          </Text>
        </Container>
      ))}
    </Card>
  );
}
